






























































































































































































































































































import './styles/page.css'
import Vue from 'vue'
import {
  cilChevronBottomAlt,
  cilHome,
  cilStarCircle,
  cilLightbulb,
  cilCog,
  cilFlightTakeoff,
  cilCommentSquareExclamation,
  cilInfo,
  cilPhone,
  cilFile,
  cilCalendar,
  cilCart,
  cilLinkIntact,
  cilArchive,
  cilShieldCheck,
cilDocument,
} from '@coreui/icons-pro'
import MenuTile from './components/MenuTile.vue'
import { mapState } from 'vuex'
import { CIcon } from '@coreui/icons-vue'
import {urlHelper} from './util/UrlHelper'



export default Vue.extend({
  name: 'App',
  computed: {
    ...mapState(['user']),
    isMobile: function () {
      return window.innerWidth <= 960
    },
  },
  components: { CIcon, MenuTile },
  data: () => ({
    drawer: false,
    mini: false,
    sideMenuUserOpen: false,
    icons: {
      dropDown: cilChevronBottomAlt,
      home: cilHome,
      favorite: cilStarCircle,
      proposal: cilLightbulb,
      mdResources: cilArchive,
      agentResources: cilCog,
      shipments: cilFlightTakeoff,
      updates: cilCommentSquareExclamation,
      iconWebsite: cilInfo,
      contacts: cilPhone,
      calendar: cilCalendar,
      externalLinks: cilLinkIntact,
      store: cilCart,
      reports: cilFile,
      reinsuranceResources: cilShieldCheck,
      econtracting: cilDocument,
    },
    urls: {
      claims: urlHelper.getApplicationUrl('claims'),
      contracts: urlHelper.getApplicationUrl('contracts', 'Application/Default.aspx'),
      estore: urlHelper.getApplicationUrl('ordering','QuickOrder/Last'),
      econtracting: urlHelper.getApplicationUrl('econtracting'),
      university: 'https://www.portfolioco.university/',
      iconSite: 'https://fandiexpress.com/',
      rateCard: urlHelper.getApplicationUrl('ratecards', 'Portals/RateCards/Overview.aspx'),
      login: urlHelper.getApplicationUrl('login'),
      logout: urlHelper.getApplicationUrl('login', 'Account/LogOff'),
      dashboard: urlHelper.getApplicationUrl('login', 'Dashboard/Index'),
      contractLookup: urlHelper.getApplicationUrl('contractlookup'),
      contacts: urlHelper.getApplicationUrl('help', 'Topics/View/General/Contact-List'),
      reportcenter: urlHelper.getApplicationUrl('reportcenter')
    },
  }),
  methods: {
    getNavigationLinks() {
      if (this.user.isAdministrator) {
        return ['Admin', 'Cost Users', 'Logout']
      }
      return ['Logout']
    },
    dropDownMenuChange(event: string) {
      switch (event) {
        case 'Logout':
          document.cookie.split(';').forEach(function (c) {
            document.cookie = c
              .replace(/^ +/, '')
              .replace(
                /=.*/,
                '=;expires=' +
                  new Date().toUTCString() +
                  ';path=/;domain=.portfolioco.com;'
              )
          })
          window.location.href =
            urlHelper.getApplicationUrl("login", "Account/LogOff")
          break
        case 'Admin':
          this.$router.push('/admins')
          break
        case 'Cost Users':
          this.$router.push('/costUsers')
      }
    },
  },
})
